export const adaptMisTareas = (misTareasData) => {
    const paciente = misTareasData.idDatosGeneralesRINavigation.idPacienteNavigation.apellido + ", " + misTareasData.idDatosGeneralesRINavigation.idPacienteNavigation.nombre;
    
    // programa
    let programa = "";
    if (misTareasData?.idDatosGeneralesRINavigation.tipoModuloRI != null) {
        for (var i=0; i<misTareasData?.idDatosGeneralesRINavigation.tipoModuloRI.length; i++) {
            if (i != 0) {
                programa += " : ";
            }
            programa += misTareasData?.idDatosGeneralesRINavigation.tipoModuloRI[i].idTipoModuloNavigation.abreviacion;
        }
    }   

    return {
        id: misTareasData?.idMisTareas,  
        idDatosGeneralesRI: misTareasData?.idDatosGeneralesRI,    
        accion: '',  
        paciente: paciente,
        programa: programa,
        fechaLimite: misTareasData?.fechaLimite,
        estado: misTareasData?.idEstado,        
        fechaEstado: misTareasData?.fechaEstado,
        tieneAdjuntos: misTareasData?.tieneAdjuntos
    }
}

export const adaptMisTareasArray = (
    misTareasData
) => {
    return structuredClone(misTareasData?.misTareas?.items)
        ?.map(tareas => adaptMisTareas(tareas));
}